import React, { useMemo, useState } from "react";

const LRSelectModal = ({
  isOpen,
  onClose,
  availableLRs,
  selectedLRs,
  setSelectedLRs,
  onConfirm,
}) => {
  const [search, setSearch] = useState("");

  //

  const toggleLR = (lr) => {
    setSelectedLRs((prev) =>
      prev.includes(lr) ? prev?.filter((i) => i !== lr) : [...prev, lr],
    );
  };

  const filteredLRs = useMemo(() => {
    return availableLRs?.filter((lr) =>
      lr.toLowerCase().includes(search.toLowerCase()),
    );
  }, [availableLRs, search]);
  if (!isOpen) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm print:hidden">
      <div className="w-full max-w-md rounded-2xl bg-white shadow-2xl overflow-hidden">
        {/* Header */}
        <div className="flex items-center justify-between px-5 py-4 border-b">
          <div>
            <h2 className="text-lg font-semibold text-slate-800">
              Select LR Numbers
            </h2>
            <p className="text-xs text-slate-500 mt-0.5">
              Choose one or more LR to add to manifest
            </p>
          </div>

          <button
            onClick={onClose}
            className="text-slate-400 hover:text-slate-600 text-xl leading-none"
            title="Close"
          >
            ✕
          </button>
        </div>

        {/* Search */}
        <div className="px-5 py-3 border-b">
          <input
            type="text"
            placeholder="Search LR number…"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="w-full rounded-lg border border-slate-300 px-3 py-2
              text-sm focus:ring-2 focus:ring-blue-500 focus:outline-none"
          />
        </div>

        {/* List */}
        <div className="max-h-72 overflow-y-auto px-5 py-3 space-y-2">
          {filteredLRs.length > 0 ? (
            filteredLRs.map((lr) => {
              const checked = selectedLRs.includes(lr);
              return (
                <label
                  key={lr}
                  className={`flex items-center justify-between px-3 py-2 rounded-lg
                    border cursor-pointer transition
                    ${
                      checked
                        ? "border-blue-500 bg-blue-50"
                        : "border-slate-200 hover:bg-slate-50"
                    }`}
                >
                  <div className="flex items-center gap-3">
                    <input
                      type="checkbox"
                      checked={checked}
                      onChange={() => toggleLR(lr)}
                      className="accent-blue-600"
                    />
                    <span className="text-sm font-medium text-slate-700">
                      {lr}
                    </span>
                  </div>

                  {checked && (
                    <span className="text-xs font-semibold text-blue-600">
                      Selected
                    </span>
                  )}
                </label>
              );
            })
          ) : (
            <div className="text-center text-sm text-slate-400 py-6">
              No LR found
            </div>
          )}
        </div>

        {/* Footer */}
        <div className="flex items-center justify-between gap-3 px-5 py-4 border-t bg-slate-50">
          <p className="text-xs text-slate-500">
            {selectedLRs.length} selected
          </p>

          <div className="flex gap-2">
            <button
              onClick={onClose}
              className="px-4 py-2 rounded-lg border border-slate-300
                text-slate-700 text-sm font-medium
                hover:bg-slate-100 transition"
            >
              Cancel
            </button>

            <button
              onClick={onConfirm}
              disabled={selectedLRs.length === 0}
              className={`px-5 py-2 rounded-lg text-sm font-semibold text-white
                transition
                ${
                  selectedLRs.length === 0
                    ? "bg-blue-300 cursor-not-allowed"
                    : "bg-blue-600 hover:bg-blue-700"
                }`}
            >
              Add Selected
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LRSelectModal;
